import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import WeeklyReportManager from "./WeeklyReportManager";
import AdminWeeklyReportManager from "./AdminWeeklyReportManager";
import { CircularProgress, Box } from "@mui/material";

const WeeklyReportIndex = () => {
    const fetchMe = async () => {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/me`, {}, {
            withCredentials: true
        });
        return response.data;
    };

    const { data: user, isLoading } = useQuery({
        queryKey: ["me"],
        queryFn: fetchMe,
        retry: false
    });

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress color="info" />
            </Box>
        );
    }

    // Role 1 & 2 are Admins
    if (user?.role_id === 1 || user?.role_id === 2) {
        return <AdminWeeklyReportManager />;
    }

    // Default to the standard manager for users/fellows
    return <WeeklyReportManager />;
};

export default WeeklyReportIndex;
